export const siteInfo = {
  name: '爱豆影视',
  tagline: '每日更新 · 高清流畅',
  h1: '爱豆影视 — 最新热播剧高清全集免费在线观看',
  slogan: '不缓冲不卡顿，追剧更畅快',
  description: '爱豆影视汇聚全网最新电视剧、热播剧、偶像剧、古装剧、都市剧高清全集资源，每日同步更新，支持高清画质流畅播放。无论您喜欢甜蜜浪漫的偶像爱情、荡气回肠的古装武侠，还是贴近生活的都市情感，这里都能满足您的追剧需求。全站免费在线观看，无需注册，打开即看，不缓冲不卡顿，为您打造极致追剧体验。当前热播推荐《星光之城》《剑啸九州》《遇见花开时》等热门剧集持续更新中。',
  stats: [
    { label: '每日更新剧集', value: '200+' },
    { label: '高清画质保障', value: '1080P' },
    { label: '海量剧集资源', value: '10000+' },
  ],
  ctaPrimary: { text: '立即追剧', href: '#media' },
  ctaSecondary: { text: '热门榜单', href: '#ranking' },
};

export const mediaData = [
  {
    id: 1,
    title: '星光之城',
    category: '都市情感',
    tag: '热播中',
    views: '1280万',
    desc: '当城市霓虹照亮梦想，两个年轻人在繁华都市中相遇相知，谱写一段温暖治愈的都市恋歌。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20urban%20romance%20drama%20poster%2C%20two%20stylish%20young%20professionals%20in%20contemporary%20city%20setting%2C%20warm%20golden%20sunset%20lighting%20through%20floor-to-ceiling%20windows%20in%20a%20high-rise%20apartment%2C%20emotional%20atmosphere%2C%20cinematic%20photography%20with%20soft%20focus%20and%20warm%20color%20grading%2C%20elegant%20composition&width=800&height=450&seq=media-01&orientation=landscape',
    link: '#media',
  },
  {
    id: 2,
    title: '剑啸九州',
    category: '古装武侠',
    tag: '更新至38集',
    views: '2360万',
    desc: '乱世之中，少年持剑踏入江湖，历经恩怨情仇，终成一代大侠的传奇故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20martial%20arts%20drama%20poster%2C%20warrior%20in%20flowing%20traditional%20robes%20standing%20on%20misty%20mountain%20peak%20at%20dawn%2C%20dramatic%20clouds%20and%20ancient%20temple%20in%20distance%2C%20epic%20cinematic%20composition%20with%20desaturated%20warm%20tones%2C%20painterly%20aesthetic%20with%20rich%20texture%20and%20atmospheric%20lighting&width=800&height=450&seq=media-02&orientation=landscape',
    link: '#media',
  },
  {
    id: 3,
    title: '遇见花开时',
    category: '偶像爱情',
    tag: '全集完结',
    views: '1890万',
    desc: '樱花树下的约定，青春校园里的甜蜜秘密，关于爱与成长的美好物语。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20idol%20romance%20drama%20poster%2C%20young%20couple%20walking%20under%20cherry%20blossom%20trees%20in%20spring%20on%20a%20university%20campus%2C%20soft%20pastel%20warm%20lighting%2C%20dreamy%20romantic%20atmosphere%2C%20cinematography%20with%20shallow%20depth%20of%20field%20and%20warm%20golden%20hour%20glow&width=800&height=450&seq=media-03&orientation=landscape',
    link: '#media',
  },
  {
    id: 4,
    title: '暗影追踪',
    category: '悬疑刑侦',
    tag: '新剧上线',
    views: '960万',
    desc: '一桩离奇案件牵出惊天阴谋，硬汉刑警与高智商罪犯之间的巅峰对决。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%2C%20detective%20in%20dark%20trench%20coat%20standing%20in%20rain-soaked%20neon-lit%20alley%20at%20night%2C%20moody%20atmospheric%20lighting%20with%20contrasting%20warm%20and%20cool%20tones%2C%20film%20noir%20aesthetic%2C%20cinematic%20composition%20with%20dramatic%20shadows%20and%20reflections&width=800&height=450&seq=media-04&orientation=landscape',
    link: '#media',
  },
];

export const commentsData = [
  {
    id: 1,
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Stylish%20young%20Chinese%20woman%20portrait%2C%20warm%20lighting%2C%20soft%20natural%20look%2C%20simple%20cream%20background%2C%20professional%20headshot%20style%20with%20gentle%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2026-07-28',
    content: '用了好多平台，还是爱豆影视最稳定！《剑啸九州》更新超快，画质也清晰，关键是真的一点都不卡，追剧体验满分！强烈推荐给所有剧荒的朋友～',
    drama: '《剑啸九州》',
  },
  {
    id: 2,
    name: '月光下的咖啡',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20casual%20stylish%20look%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20professional%20headshot%20style%20with%20friendly%20smile&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '2026-07-26',
    content: '《星光之城》太好看了！男女主角的演技都在线，剧情也不拖沓，每天下班回家第一件事就是打开爱豆影视追更新，已经推荐给全办公室的同事了。',
    drama: '《星光之城》',
  },
  {
    id: 3,
    name: '古风控一枚',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%2C%20elegant%20style%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20professional%20headshot%20style%20with%20gentle%20confident%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '2026-07-25',
    content: '古装剧资源太全了！之前找好久的经典老剧这里都有，画质修复得也很棒。《剑啸九州》的服化道简直是国产古装剧天花板，爱豆影视的1080P画质让每一帧都能当壁纸！',
    drama: '《剑啸九州》',
  },
];

export const contactData = {
  title: '剧集投稿与合作',
  desc: '如果您有优质剧集资源推荐、内容合作建议或任何意见反馈，欢迎通过以下方式联系我们。爱豆影视期待与更多优质内容创作者携手，为观众带来更好的追剧体验。',
  email: 'contact@aidou.tv',
  wechat: 'aidou_yingshi',
};

export const indexData = [
  { id: 1, title: '古装剧专场', desc: '江湖恩怨与宫廷风云', count: '326部', icon: 'ri-sword-line', link: '#index' },
  { id: 2, title: '偶像剧合集', desc: '甜蜜浪漫心动时刻', count: '218部', icon: 'ri-heart-line', link: '#index' },
  { id: 3, title: '都市剧精选', desc: '现代生活真实写照', count: '285部', icon: 'ri-building-line', link: '#index' },
  { id: 4, title: '悬疑剧场', desc: '烧脑推理环环相扣', count: '167部', icon: 'ri-search-eye-line', link: '#index' },
  { id: 5, title: '武侠经典', desc: '快意恩仇侠骨柔情', count: '142部', icon: 'ri-knife-line', link: '#index' },
  { id: 6, title: '高分韩剧', desc: '口碑佳作原声字幕', count: '198部', icon: 'ri-star-line', link: '#index' },
  { id: 7, title: '热播日剧', desc: '治愈日常温情短篇', count: '153部', icon: 'ri-sun-line', link: '#index' },
  { id: 8, title: '美剧精选', desc: '高分神剧一网打尽', count: '176部', icon: 'ri-global-line', link: '#index' },
  { id: 9, title: '动漫频道', desc: '热血青春二次元', count: '312部', icon: 'ri-rocket-line', link: '#index' },
];

export const featuresData = [
  { id: 1, title: '高清画质', desc: '1080P超清画质，支持多档清晰度自由切换，为您呈现每一个细腻画面细节。', icon: 'ri-4k-line' },
  { id: 2, title: '流畅播放', desc: '全球CDN加速节点覆盖，智能码率自适应技术，不缓冲不卡顿，追剧体验丝滑流畅。', icon: 'ri-speed-line' },
  { id: 3, title: '海量剧集', desc: '超过10000部电视剧资源持续更新，涵盖偶像剧、古装剧、都市剧等全品类内容。', icon: 'ri-database-2-line' },
  { id: 4, title: '每日更新', desc: '每日同步更新200+最新剧集，热门剧集第一时间上线，绝不错过任何精彩内容。', icon: 'ri-refresh-line' },
];

export const topicsData = [
  { id: 1, tag: '#星光之城热播', heat: '🔥 980万讨论' },
  { id: 2, tag: '#剑啸九州大结局', heat: '🔥 850万讨论' },
  { id: 3, tag: '#遇见花开时名场面', heat: '🔥 720万讨论' },
  { id: 4, tag: '#暗影追踪凶手是谁', heat: '🔥 680万讨论' },
  { id: 5, tag: '#2026暑期档必追', heat: '📈 560万讨论' },
  { id: 6, tag: '#国产古装剧天花板', heat: '📈 490万讨论' },
  { id: 7, tag: '#都市剧新标杆', heat: '📈 430万讨论' },
  { id: 8, tag: '#悬疑剧推荐', heat: '💬 380万讨论' },
  { id: 9, tag: '#偶像剧OST合集', heat: '💬 320万讨论' },
  { id: 10, tag: '#武侠剧经典回顾', heat: '💬 290万讨论' },
];

export const faqData = [
  {
    id: 1,
    question: '爱豆影视需要注册账号才能观看吗？',
    answer: '不需要。爱豆影视所有剧集资源完全免费，无需注册登录即可直接在线观看，打开网站就能开始追剧，没有任何门槛限制。',
  },
  {
    id: 2,
    question: '播放画质如何？会不会经常缓冲卡顿？',
    answer: '爱豆影视提供最高1080P超清画质，并支持多档清晰度自由切换。我们采用全球CDN加速和智能码率自适应技术，确保播放流畅不卡顿，带给您极致的追剧体验。',
  },
  {
    id: 3,
    question: '剧集更新速度快吗？热播剧多久会上线？',
    answer: '我们每日同步更新200+最新剧集内容，热门剧集在播出后第一时间上线。无论是国产热播剧还是海外口碑剧，都能在爱豆影视快速追更。',
  },
  {
    id: 4,
    question: '网站上都有哪些类型的剧集资源？',
    answer: '爱豆影视涵盖偶像剧、古装剧、都市剧、悬疑剧、武侠剧、韩剧、日剧、美剧、动漫等多种品类，超过10000部剧集资源持续扩充，满足不同观众的追剧喜好。',
  },
];

export const updatesData = [
  { id: 1, date: '07月28日', title: '《星光之城》第24集更新上线', tag: '新剧更新' },
  { id: 2, date: '07月28日', title: '《剑啸九州》第38集大结局抢先看', tag: '大结局' },
  { id: 3, date: '07月27日', title: '《暗影追踪》全12集一次性上线', tag: '新剧上线' },
  { id: 4, date: '07月27日', title: '《遇见花开时》全集完结，口碑持续走高', tag: '全集完结' },
  { id: 5, date: '07月26日', title: '暑期档专题"武侠经典回顾"正式上线', tag: '专题上线' },
  { id: 6, date: '07月25日', title: '平台新增4K画质选项，部分剧集已支持', tag: '功能升级' },
  { id: 7, date: '07月24日', title: '《都市律动》第三季官宣定档8月15日', tag: '定档预告' },
  { id: 8, date: '07月23日', title: '韩剧专区新增《月之恋歌》全16集', tag: '海外剧集' },
  { id: 9, date: '07月22日', title: '播放器全面升级，新增倍速与记忆续播', tag: '体验优化' },
];

export const rankingData = [
  { id: 1, rank: 1, title: '剑啸九州', category: '古装武侠', hot: '2360万', trend: 'up' },
  { id: 2, rank: 2, title: '星光之城', category: '都市情感', hot: '1280万', trend: 'up' },
  { id: 3, rank: 3, title: '遇见花开时', category: '偶像爱情', hot: '1890万', trend: 'stable' },
  { id: 4, rank: 4, title: '暗影追踪', category: '悬疑刑侦', hot: '960万', trend: 'up' },
  { id: 5, rank: 5, title: '都市律动', category: '都市职场', hot: '850万', trend: 'down' },
];

export const cardsData = [
  {
    id: 1,
    title: '古装剧巅峰之作',
    subtitle: '《剑啸九州》深度解读',
    desc: '服化道细节拉满，打戏行云流水，剧情层层递进，被称为2026年国产古装剧天花板。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20fantasy%20drama%20scene%2C%20magnificent%20ancient%20palace%20interior%20with%20golden%20dragon%20decorations%2C%20warm%20amber%20candlelight%20illumination%2C%20rich%20red%20and%20gold%20color%20palette%2C%20cinematic%20wide-angle%20composition%20with%20intricate%20architectural%20details%20and%20atmospheric%20depth&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '都市情感新标杆',
    subtitle: '《星光之城》为何爆火',
    desc: '真实细腻的都市生活刻画，全员演技在线，每个角色都有血有肉，引发观众强烈共鸣。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20workplace%20drama%20scene%2C%20stylish%20office%20interior%20with%20floor-to-ceiling%20windows%20overlooking%20futuristic%20city%20skyline%20at%20dusk%2C%20warm%20ambient%20lighting%2C%20sophisticated%20corporate%20atmosphere%2C%20cinematic%20composition%20with%20dramatic%20natural%20light%20and%20reflections&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '韩剧专区精选',
    subtitle: '不可错过的口碑佳作',
    desc: '精选高分韩剧资源，原声字幕呈现，从浪漫爱情到悬疑烧脑，承包你的追剧清单。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%2C%20couple%20in%20autumn%20park%20with%20golden%20falling%20leaves%2C%20warm%20soft%20backlight%2C%20emotional%20cinematography%20with%20dreamy%20atmosphere%2C%20Korean%20drama%20aesthetic%20with%20shallow%20depth%20of%20field&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑剧迷必看',
    subtitle: '《暗影追踪》全程高能',
    desc: '节奏紧凑不拖沓，反转不断猜不到结局，演技炸裂的对手戏让每一集都像电影级别。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20thriller%20drama%20interrogation%20room%20scene%2C%20intense%20confrontation%20between%20detective%20and%20suspect%2C%20dramatic%20overhead%20lighting%20with%20deep%20shadows%2C%20cinematic%20composition%20with%20cool%20and%20warm%20tone%20contrast&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '暑期追剧指南',
    subtitle: '2026暑假必刷清单',
    desc: '整理最全日程表，古装偶像悬疑都市全覆盖，这个暑假再也不怕剧荒无聊了。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20summer%20living%20room%20with%20large%20TV%20screen%2C%20comfortable%20sofa%20with%20blanket%2C%20warm%20evening%20ambient%20lighting%2C%20cinematic%20home%20entertainment%20setup%2C%20relaxing%20atmosphere%20with%20soft%20warm%20glow&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '动漫频道上线',
    subtitle: '热血青春一网打尽',
    desc: '国漫日漫经典与最新番剧同步更新，二次元爱好者专属频道，高清画质畅快追番。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20vibrant%20fantasy%20cityscape%20with%20colorful%20neon%20lights%2C%20dynamic%20composition%20with%20action%20energy%2C%20warm%20and%20cool%20color%20contrast%2C%20cinematic%20wide%20shot%20with%20stylized%20aesthetic&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export const appData = {
  title: '随时随地，追剧不停',
  desc: '爱豆影视移动端适配全面优化，在手机、平板等移动设备上同样享受高清流畅的追剧体验。打开浏览器即可观看，无需下载安装，随时随地畅享海量剧集。支持收藏、历史记录和继续观看功能，追剧进度不再丢失。',
  features: ['高清画质适配', '流量优化播放', '收藏与续播', '多设备同步'],
};

export const carouselData = [
  {
    id: 1,
    title: '武侠经典回顾',
    subtitle: '重温那些年最燃的江湖',
    desc: '从金庸到古龙，从经典翻拍到原创武侠，精选20部口碑武侠剧带你重温江湖豪情。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20landscape%2C%20misty%20mountain%20peaks%20with%20ancient%20temples%2C%20dramatic%20sunrise%20lighting%20with%20warm%20golden%20and%20soft%20pink%20tones%2C%20painterly%20Chinese%20ink%20wash%20painting%20aesthetic%2C%20cinematic%20wide%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '暑期追剧计划',
    subtitle: '这个夏天不容错过的热剧',
    desc: '精心策划暑期追剧日历，每天都有新惊喜，偶像古装悬疑都市一网打尽，告别剧荒。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20evening%20outdoor%20cinema%20scene%2C%20string%20lights%20and%20comfortable%20seating%2C%20warm%20golden%20hour%20atmosphere%2C%20cozy%20backyard%20movie%20night%20with%20friends%2C%20cinematic%20wide%20shot%20with%20soft%20bokeh%20lights&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '韩剧精选合集',
    subtitle: '高分口碑韩剧一网打尽',
    desc: '从经典催泪到甜蜜浪漫，从悬疑烧脑到治愈日常，精选50部必看韩剧带字幕呈现。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%20scene%2C%20couple%20walking%20along%20seaside%20at%20sunset%2C%20warm%20romantic%20lighting%20with%20soft%20golden%20and%20pink%20sky%2C%20cinematic%20cinematography%20with%20emotional%20depth%2C%20Korean%20film%20aesthetic&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '高分都市剧推荐',
    subtitle: '职场生存与都市爱情',
    desc: '贴近现实生活的都市剧精选，描绘当代年轻人的奋斗、爱情与成长，真实而动人。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20skyline%20at%20dusk%2C%20warm%20golden%20light%20reflecting%20on%20glass%20buildings%2C%20busy%20urban%20street%20with%20stylish%20young%20professionals%2C%20cinematic%20cityscape%20photography%20with%20rich%20warm%20color%20palette&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '动漫燃魂剧场',
    subtitle: '二次元的无限可能',
    desc: '国漫崛起与日漫经典的双重盛宴，从热血战斗到唯美治愈，总有一部戳中你的心。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%20fantasy%20world%2C%20vibrant%20colorful%20celestial%20landscape%20with%20floating%20islands%20and%20cherry%20blossoms%2C%20warm%20sunset%20lighting%20with%20magical%20glow%2C%20cinematic%20wide%20composition%20with%20stylized%20Japanese%20anime%20aesthetic&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于爱豆影视',
  desc: '爱豆影视成立于2024年，是一家专注于高清电视剧在线播放的综合影视平台。我们致力于为全球华语观众提供最新、最全、最流畅的追剧体验。\n\n平台汇聚超过10000部偶像剧、古装剧、都市剧、悬疑剧、武侠剧以及海外精选剧集资源，每日同步更新200+最新剧集内容。我们采用先进的视频编码技术和全球CDN加速网络，确保每一位用户都能享受不缓冲不卡顿的高清播放体验。\n\n爱豆影视始终坚持"免费、高清、流畅"的核心理念，无需注册、无需付费，打开即可观看。我们相信，好的内容应该被更多人看到，好的追剧体验应该属于每一个人。',
  stats: [
    { label: '剧集总数', value: '10,000+' },
    { label: '日均更新', value: '200+' },
    { label: '月活用户', value: '500万+' },
    { label: '上线年份', value: '2024' },
  ],
};

export const footerData = {
  description: '爱豆影视 — 最新热播剧高清全集免费在线观看平台。偶像剧、古装剧、都市剧、悬疑剧、韩剧、日剧、美剧、动漫全覆盖，每日更新，不缓冲不卡顿，畅享极致追剧体验。',
  links: {
    drama: [
      { title: '偶像剧', href: '#index' },
      { title: '古装剧', href: '#index' },
      { title: '都市剧', href: '#index' },
      { title: '悬疑剧', href: '#index' },
    ],
    platform: [
      { title: '关于我们', href: '#about' },
      { title: '联系合作', href: '#contact' },
      { title: '常见问题', href: '#faq' },
      { title: '最新动态', href: '#updates' },
    ],
    hot: [
      { title: '星光之城', href: '#media' },
      { title: '剑啸九州', href: '#media' },
      { title: '暗影追踪', href: '#media' },
      { title: '热度榜单', href: '#ranking' },
    ],
  },
};

export const headerNav = [
  { title: '首页', href: '#hero' },
  { title: '最新动态', href: '#updates' },
  { title: '专题合集', href: '#index' },
  { title: '焦点专题', href: '#carousel' },
  { title: '热播推荐', href: '#media' },
  { title: '关于爱豆', href: '#about' },
];